import { FileLinks } from 'admin/documents/FileLinks';
import { MotorLiabilityInsuranceProduct } from 'generated/graphql';
import {
  ArrayField,
  BooleanField,
  DateField,
  FunctionField,
  NumberField,
  ReferenceField,
  Show,
  SingleFieldList,
  TabbedShowLayout,
  TextField,
} from 'react-admin';

export const MotorLiabilityInsuranceProductShow: React.FC = () => (
  <Show>
    <TabbedShowLayout>
      <TabbedShowLayout.Tab label="Základné info">
        <TextField label="ID" source="id" />
        <ReferenceField label="Klient" link="show" reference="Client" source="client.id">
          <TextField source="user.email" />
        </ReferenceField>
        <TextField label="Inštitúcia" source="institution.name" />
        <TextField label="Vlastná inštitúcia" source="institutionName" />
        <TextField label="Názov produktu" source="name" />
        <BooleanField label="Starostlivosť" source="enableFinancialAdvisorCare" />
        <ArrayField label="Dokumenty" source="documents">
          <SingleFieldList linkType={false}>
            <ArrayField source="files">
              <FileLinks />
            </ArrayField>
          </SingleFieldList>
        </ArrayField>
      </TabbedShowLayout.Tab>

      <TabbedShowLayout.Tab label="Zmluva">
        <TextField label="Číslo zmluvy" source="contractNumber" />
        <DateField label="Začiatok poistenia" locales="sk" source="contractSignDate" />
        <DateField label="Platnosť poistenia do" locales="sk" source="contractEndDate" />
      </TabbedShowLayout.Tab>

      <TabbedShowLayout.Tab label="Platby">
        <FunctionField
          label="Suma poistného"
          render={(record: MotorLiabilityInsuranceProduct) =>
            record.paymentPeriod?.expectedAmount?.amount ? -record.paymentPeriod?.expectedAmount?.amount : undefined
          }
          source="paymentPeriod.expectedAmount.amount"
        />
        <TextField label="Opakovať každých" source="paymentPeriod.periodCount" />
        <TextField label="" source="paymentPeriod.periodTypeCode" />
        <DateField label="Nasledujúca platba" locales="sk" source="paymentPeriod.expectedDate" />
      </TabbedShowLayout.Tab>

      <TabbedShowLayout.Tab label="Údaje pre platbu">
        <TextField label="Variabilný symbol" source="paymentInfo.variableSymbol" />
        <TextField label="Špecifický symbol" source="paymentInfo.specificSymbol" />
        <TextField label="Konštantný symbol" source="paymentInfo.constantSymbol" />
        <TextField label="IBAN" source="paymentInfo.ibanForPayment" />
      </TabbedShowLayout.Tab>

      <TabbedShowLayout.Tab label="Poistené vozidlo">
        <TextField label="Typ vozidla" source="vehicleInfo.type" />
        <TextField label="ŠPZ" source="vehicleInfo.licenseNumber" />
      </TabbedShowLayout.Tab>

      <TabbedShowLayout.Tab label="Poistník">
        <TextField label="Typ poistníka" source="insuringPerson.type" />
        <TextField label="Názov spoločnosti / Meno" source="insuringPerson.name" />
      </TabbedShowLayout.Tab>

      <TabbedShowLayout.Tab label="Údaje pre porovnanie výhodnosti produktu">
        <DateField label="Dátum narodenia" locales="sk" source="vehicleInfo.owner.dateOfBirth" />
        <TextField label="PSČ" source="vehicleInfo.owner.postalCode" />
        <NumberField label="Rok poslednej nehody" source="vehicleInfo.owner.yearOfLastCollision" />
        <NumberField label="Počet nehôd za 3 roky" source="vehicleInfo.owner.numberOfRecentCollisions" />
      </TabbedShowLayout.Tab>

      <TabbedShowLayout.Tab label="Status">
        <TextField label="Status" source="status" />
        <DateField label="Zmena stavu" locales="sk" source="statusChangeDate" />
      </TabbedShowLayout.Tab>
    </TabbedShowLayout>
  </Show>
);
